import { setCookie, removeCookie, getCookie } from 'Utils/Cookies';
import { SESSION } from 'constants/session';

export const AuthService = {
  setSession({ token, userId, userName, firstName, lastName, emailAddress }) {
    const exp = SESSION.EXP_MINUTES;
    setCookie(SESSION.TOKEN_COOKIE_KEY, token, exp);
    setCookie(SESSION.USER_ID, userId, exp);
    setCookie(SESSION.USER_NAME, userName, exp);
    setCookie(SESSION.FIRST_NAME, firstName, exp);
    setCookie(SESSION.LAST_NAME, lastName, exp);
    setCookie(SESSION.EMAIL, emailAddress, exp);
  },
  clearSession() {
    removeCookie(SESSION.TOKEN_COOKIE_KEY);
    removeCookie(SESSION.USER_ID);
    removeCookie(SESSION.USER_NAME);
    removeCookie(SESSION.FIRST_NAME);
    removeCookie(SESSION.LAST_NAME);
    removeCookie(SESSION.EMAIL);
  },
  getToken() {
    return getCookie(SESSION.TOKEN_COOKIE_KEY);
  },
  getSession() {
    return {
      token: getCookie(SESSION.TOKEN_COOKIE_KEY),
      userId: getCookie(SESSION.USER_ID),
      userName: getCookie(SESSION.USER_NAME),
      firstName: getCookie(SESSION.FIRST_NAME),
      lastName: getCookie(SESSION.LAST_NAME),
      emailAddress: getCookie(SESSION.EMAIL),
    };
  },
};


